module.exports = __webpack_public_path__ + "img/Trustor rule.2c4b6c37.svg";